import React from "react";
import "./Orders.css";
import { Filter, Eye, X } from "lucide-react";
import { FaSort, FaSortUp, FaSortDown, FaEye } from "react-icons/fa";
import { useOrders } from "../../customHooks/Orders/useOrders";
import Pagination from "../../components/Pagination/Pagination";
import {
  formatCurrency,
  formatDate,
  mapStatusToBootstrap,
} from "../../components/Constants/Constants";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../components/AppLoader/appLoader";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import usePermission from "../../utils/usePermission";
import { useSelector } from "react-redux";
import CopyIcon from "../../components/CopyIcon/CopyIcon";

const Orders = () => {
  const {
    orders,
    loading,
    totalOrderCount,
    filters,
    setFilters,
    handleFilterChange,
    clearFilters,
    sortConfig,
    handleSort,
    paginatedOrders,
    totalPages,
    currentPage,
    startItem,
    endItem,
    goToPage,
    itemsPerPage,
    setItemsPerPage,
    itemsPerPageOptions,
    handleItemsPerPageChange,
    filterOptions,
    selectedOption,
    setSelectedOption,
    searchValue,
    setSearchValue,
    handleDropdownChange,
    handleSearchChange,
    selectedOrders,
    setSelectedOrders,
    handleCheckboxToggle,
    allSelected,
    handleSelectAll,
    searchOptions,
    sendSettlementRequest,
  } = useOrders();

  const canViewOrders = usePermission("ORDER_LISTING_VIEW");
  const canAccessSettlement = usePermission("REQUEST_SETTLEMENT_ACCESS");

  const isCheckboxVisible =
    filters.buyer_app_id &&
    (filters.settlement_status === "PENDING" ||
      filters.settlement_status === "TO_BE_INITIATED");

  const navigate = useNavigate();
  return (
    <>
      {canViewOrders ? (
        <div>
          {selectedOrders.length > 0 && (
            <div className="d-flex justify-content-end align-items-center mt-2">
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{ padding: "4px 8px", fontSize: "14px" }}
                onClick={sendSettlementRequest}
                disabled={!canAccessSettlement}
              >
                Send Settlement Request
              </button>
            </div>
          )}

          <div className="filters-wrapper bg-white px-3 py-2 rounded shadow-sm">
            <div className="row gx-4 gy-3 align-items-end flex-wrap">
              {/* Search Section */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Search By
                </label>
                <div className="d-flex align-items-center">
                  <select
                    className="form-select"
                    value={selectedOption}
                    onChange={handleDropdownChange}
                    style={{
                      width: "150px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    {searchOptions?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    value={searchValue}
                    onChange={handleSearchChange}
                    placeholder={`${selectedOption
                      .split("_") // Split by underscores
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      ) // Capitalize first letter of each word
                      .join(" ")}`} // Join words back with a space
                    style={{
                      width: "200px",
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0",
                    }}
                  />
                </div>
              </div>

              {/* Dynamic Filters */}
              {/* Buyer App */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Buyer App
                </label>
                <select
                  className="form-select"
                  value={filters.buyer_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("buyer_app_id", e.target.value)
                  }
                  style={{ minWidth: "140px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.buyerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {/* Seller App */}
              {/* <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Seller App
                </label>
                <select
                  className="form-select"
                  value={filters.seller_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("seller_app_id", e.target.value)
                  }
                  style={{ minWidth: "140px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.sellerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> */}

            
               <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Order Status
                </label>
                <select
                  className="form-select"
                  value={filters.order_status || ""}
                  onChange={(e) =>
                    handleFilterChange("order_status", e.target.value)
                  }
                  style={{ minWidth: "120px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.orderStatuses?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> 

              {/* Settlement Status */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Settlement Status
                </label>
                <select
                  className="form-select"
                  value={filters.settlement_status || ""}
                  onChange={(e) =>
                    handleFilterChange("settlement_status", e.target.value)
                  }
                  style={{ minWidth: "120px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.settlementStatuses?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-auto">
                <label
                  className="form-label mb-1.5"
                  style={{ fontSize: "0.8rem" }}
                >
                  Order Created Between
                </label>
                <div className="d-flex flex-wrap gap-3">
                  {/* FROM Date */}
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.7rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      From
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.order_created_at_from}
                      onChange={(e) =>
                        handleFilterChange(
                          "order_created_at_from",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  {/* TO Date */}
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.75rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      To
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.order_created_at_to}
                      onChange={(e) =>
                        handleFilterChange(
                          "order_created_at_to",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Clear Filters Button */}
              <div className="col-auto">
                <button
                  type="button"
                  className="clearFilter d-flex align-items-center"
                  onClick={clearFilters}
                >
                  <i className="bi bi-x-circle me-1"></i>
                  Reset Filters
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <AppLoader />
          ) : (
            <>
              <div
                className="table-responsive mt-4"
                style={{ overflowX: "auto" }}
              >
                <table
                  className="table table-bordered table-hover align-middle"
                  style={{ minWidth: "1200px" }}
                >
                  <thead className="table-light">
                    <tr>
                      {isCheckboxVisible && (
                        <th style={{ width: "40px" }}>
                          <input
                            type="checkbox"
                            onChange={handleSelectAll} // implement this function
                            checked={allSelected} // boolean state
                          />
                        </th>
                      )}
                      <th style={{ minWidth: "150px" }}>Buyer Order ID</th>
                      <th style={{ minWidth: "150px" }}>Seller Order ID</th>
                      <th style={{ minWidth: "150px" }}>Txn. ID</th>
                      <th style={{ minWidth: "150px" }}>Order Status</th>
                      <th style={{ minWidth: "150px" }}>Settlement Status</th>
                      <th
                        style={{ minWidth: "100px" }}
                        onClick={() => handleSort("order_amount")}
                        role="button"
                      >
                        Amount &nbsp;
                        {sortConfig.key === "order_amount" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                      <th
                        style={{ minWidth: "100px" }}
                        onClick={() => handleSort("finder_fee_amount")}
                        role="button"
                      >
                        Finder Fee &nbsp;
                        {sortConfig.key === "finder_fee_amount" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                      <th style={{ minWidth: "150px" }}>Buyer App</th>
                      <th style={{ minWidth: "150px" }}>Seller App</th>
                      <th
                        style={{ minWidth: "150px" }}
                        onClick={() => handleSort("order_created_at")}
                        role="button"
                      >
                        Created At &nbsp;
                        {sortConfig.key === "order_created_at" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedOrders && paginatedOrders.length > 0 ? (
                      paginatedOrders.map((order, index) => (
                        <tr key={`${order.id}-${index}`}>
                          {isCheckboxVisible && (
                            <td style={{ minWidth: "40px" }}>
                              <input
                                type="checkbox"
                                onChange={() => handleCheckboxToggle(order.id)}
                                checked={selectedOrders.includes(order.id)}
                                disabled={
                                  !(
                                    order.settlement_status === "PENDING" ||
                                    order.settlement_status ===
                                      "TO_BE_INITIATED"
                                  )
                                }
                              />
                            </td>
                          )}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span
                              onClick={() =>
                                navigate(`/orders/${order.buyer_order_id}`)
                              }
                              style={{
                                cursor: "pointer",
                                color: "#0d6efd",
                                fontWeight: 500,
                                textDecoration: "none",
                              }}
                              title="View Order Details"
                              className="truncate-cell"
                            >
                              {order.buyer_order_id}
                            </span>
                            {/* The CopyIcon component is placed here */}
                            <CopyIcon textToCopy={order.buyer_order_id} />
                          </td>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {order.seller_order_id}
                            </span>

                            {/* The CopyIcon component */}
                            <CopyIcon textToCopy={order.seller_order_id} />
                          </td>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {order.txn_id}
                            </span>
                            <CopyIcon textToCopy={order.txn_id} />
                          </td>
                          <td style={{ minWidth: "150px" }}>
                            <span
                              style={{ fontSize: "12px" }}
                              className={mapStatusToBootstrap(
                                order.order_status
                              )}
                            >
                              {order.order_status}
                            </span>
                          </td>
                          <td style={{ minWidth: "150px" }}>
                            {order.settlement_status}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {formatCurrency(order.total_order_amount)}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {formatCurrency(order.finder_fee_amount)}
                          </td>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {order.buyer_app_id}
                            </span>
                            <CopyIcon textToCopy={order.buyer_app_id} />
                          </td>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {order.seller_app_id}
                            </span>
                            <CopyIcon textToCopy={order.seller_app_id} />
                          </td>
                          <td style={{ minWidth: "150px" }}>
                            {formatDate(order.order_created_at)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={11}
                          className="text-center py-4 text-gray-500"
                        >
                          No Orders Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {totalOrderCount > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              totalItems={totalOrderCount}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
              onPageChange={goToPage}
              itemsPerPageOptions={itemsPerPageOptions}
            />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
};

export default Orders;
